import { Pipe, PipeTransform } from '@angular/core';

/**
 * Accepts a file and returns the file size formatted in KB or MB.
 */

@Pipe({
  name: 'getFileSize',
})
export class GetFileSizePipe implements PipeTransform {
  transform(value: File | null): string {
    if (!value) return '0';
    const sizeInKB = value.size / 1000;

    if (sizeInKB >= 1000) {
      const sizeInMB = sizeInKB / 1000;
      return $localize`${sizeInMB.toFixed(2)} MB`;
    } else {
      return $localize`${sizeInKB.toFixed(2)} KB`;
    }
  }
}
